import { CurrencyEnum } from '@/enums';

export const amountToString = (amount: number, currency: CurrencyEnum) =>
  new Intl.NumberFormat('fr', { style: 'currency', currency })
    .format(amount ?? 0)